import { corporationsMutations, corporationsActions} from './corporations.js';
import { shopsActions, shopsMutations } from './shops.js';
import { licActions, licMutations } from './lic.js';
import { apiMedia } from '@/api/api-media.js'

const state = {
  corporations: {
    items: []
  },
  shops: {
    items: []
  },
  dealers: [],
  template: ""
}

const mutations = {
  ...corporationsMutations,
  ...shopsMutations,
  ...licMutations,
}

const actions = {
  ...corporationsActions,
  ...shopsActions,
  ...licActions,

  async process_image(ctx, payload){
    const result = await apiMedia.send_image(payload)
    return result
  }
}

const getters = {
  corporations: state => state.corporations,
  shops: state => state.shops,
  corporation: state => (id) => state.corporations?.items?.find(corporation => corporation.id == id),
  shop: state => (id) => state.shops?.items?.find(shop => shop.id == id),
  dealers: state => state.dealers,
  template: state => state.template,
}

export default{
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}